import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterestTierrateFormatFormatPipe } from './interest-tierrate-format.pipe';

@NgModule({
  declarations: [InterestTierrateFormatFormatPipe],
  imports: [CommonModule],
  exports: [InterestTierrateFormatFormatPipe],
})
export class InterestTierrateFormatModule {}
